import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import ElementModel from "../../model/ElementModel";

export class PageAdminProductsWithoutImageStore {
    private rootStore: RootStore | undefined;
    public arDataProduct = [];
    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init = () => {
        this.arDataProduct = [];
        this.reload();
    }

    @action
    reload() {
        ElementModel.getProductsWithoutImage({}, this.setData, this.setError);
    }

    @action
    setData = (result: any) => {
        console.log(result)
        this.arDataProduct = result.data[0]
    }

    @action setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }

    
}
